export default __webpack_public_path__ + "static/instant-funding-284d44b7654a61e9964e195d5b5c4b71.jpg";